export default __webpack_public_path__ + "static/media/BrainBreak cards11.1dea3091.png";